export default __webpack_public_path__ + "static/banner-67bd017cb26a4c0c62cb984f20635e64.png";